import apiClient from '../../apiClient';
import { ErrorType } from '../../commonType';
import { createError, NO_OFFER } from '../../util/errorString';
//import { createError, NO_OFFER } from '../../util';
import { Offer, OfferDetails, OfferRequest, OfferResponse, State } from './types';
//const { get, post, put, deleteRequest, patch } = useAPIClient();

//import response from '../OfferStateSelect/Service/offerbyloc.json';

const OFFER_BY_PIN_API_END_POINT = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_OFFER_BY_PIN_API_PATH}`;

const getDistinctState = (stateList: State[]): State[] => {
  const distinctStateCodeList = Array.from(new Set(stateList.map((s) => s.stateCode)));
  const states: State[] = distinctStateCodeList.map((code) => {
    return {
      stateCode: code,
      stateName: stateList.find((e) => e.stateCode === code)?.stateName,
    };
  });
  return states;
};

const fetchOfferData = async (
  pin: string,
  lastName: string,
  fetchOffer: string,
  pinOptFlow: boolean,
): Promise<OfferDetails> => {
  const offerRequest: OfferRequest = {
    getOfferDetails: fetchOffer,
    lastName: lastName,
    pin: pin,
  };
  const pinOptOfferRequest: any = {
    getOfferDetails: fetchOffer,
    lastName: lastName,
    pin: pin,
    optFlow: 'y',
  };
  const payLoadReq = pinOptFlow ? pinOptOfferRequest : offerRequest;

  let returnValue: OfferDetails = {
    hasError: false,
    loading: false,
    showProspect: false,
    hasOffers: false,
    displayFlipOffers: false,
    searchParameter: '',
    showCTA: false,
    isPackageSold: false,
    isPin: true,
  };
  const primaryOfferLocationCollection: State[] = [];
  const flipOfferLocationCollection: State[] = [];
  try {
    const offerResponse = await apiClient.post<any, OfferResponse>(OFFER_BY_PIN_API_END_POINT, payLoadReq);
    const isPackageSold = offerResponse.packageSold && offerResponse.packageSold.toLocaleLowerCase() === 'y';
    if (isPackageSold) {
      returnValue.isPackageSold = true;
      returnValue.showCTA = true;
      returnValue.callCenterNumber = offerResponse.callCenterNumber !== '' ? offerResponse.callCenterNumber : '';
      returnValue.callCenterCode = offerResponse?.callCenterCode || '';
      return returnValue;
    }
    if (fetchOffer.toLocaleLowerCase() === 'n') {
      returnValue.callCenterNumber = offerResponse.callCenterNumber;
    }

    returnValue.searchParameter = pin;
    returnValue.prospect = offerResponse.prospect;
    if (returnValue.prospect) {
      returnValue.showProspect = true;
    }
    if (fetchOffer.toLocaleLowerCase() === 'y') {
      const offers = offerResponse.offers;

      returnValue.isDatedOffer = offers[0].showCalendar && offers[0].showCalendar === 'S' ? true : false;

      if (offers && offers.length > 0) {
        returnValue.pinOptOfferDetails = offerResponse;
        const primaryOffer = offers.filter((e) => !e.isFlip);
        offers.forEach((e) => {
          e.includeOffer = true;
          if (e.premiums && e.premiums.length > 0) {
            const temp: string[] = [];
            e.premiums.forEach((x) => {
              if (x !== null) {
                let premium = x.replace('<p>', '');
                premium = premium.replace('</p>', '');
                if (x.indexOf('BonvoyTM') > 0) {
                  premium = premium.replace('BonvoyTM', 'Bonvoy<sup>TM</sup>');
                }
                temp.push(premium);
              }
            });
            e.premiums = temp;
          }
          if (e.roomTypes && e.roomTypes.length > 0) {
            const rooms = e.roomTypes.filter((x) => x.sequenceNumber === 1);
            const primaryRoom = rooms && rooms.length > 0 ? rooms[0] : e.roomTypes[0];
            e.offerDays = primaryRoom.numberOfDays;
            e.offerNights = primaryRoom.numberOfNights;
            e.offerMaxGuest = primaryRoom.sleepCapacity;
            e.offerDescription = primaryRoom.roomTypeDescription;
            e.property = primaryRoom.property;
            if (e.property && e.property.stateProvince && e.property.stateProvince) {
              const stateInfo: State = {
                stateCode: e.property?.stateCode,
                stateName: e.property?.stateProvince,
              };
              e.offerLocation = stateInfo;
              if (e.isFlip) {
                flipOfferLocationCollection.push(e.offerLocation);
              } else {
                primaryOfferLocationCollection.push(e.offerLocation);
              }
            }
          }
        });
        if (primaryOffer && primaryOffer.length > 0) {
          const flipOffers: Offer[] = offers.filter((e) => e.isFlip);

          returnValue.hasOffers = true;
          returnValue.primaryOffer = primaryOffer;
          returnValue.flipOffers = flipOffers;
          const currentOffer = primaryOffer[0];
          returnValue.currentOffer = currentOffer;
          returnValue.locDescription = currentOffer.locDescription;
          returnValue.property = currentOffer.property;
          returnValue.primaryOfferLocations = getDistinctState(primaryOfferLocationCollection);
          returnValue.flipOfferLocations = getDistinctState(flipOfferLocationCollection);
        } else {
          returnValue.hasOffers = false;
        }
        returnValue.hasError = false;
      } else {
        returnValue.hasOffers = false;
        returnValue.hasError = true;
        returnValue.error = { errorType: ErrorType.Error, errorMessageKey: NO_OFFER };
      }
    }
  } catch (e: any) {
    returnValue.hasError = true;
    if (e.response && e.response.data && e.response.data.errorCode) {
      returnValue.errorCode = e.response.data.errorCode;
      returnValue.callCenterNumber = e.response.data.callCenterNumber;
      const {
        response: {
          data: { errorCode },
        },
      } = e;
      returnValue.error = createError(errorCode);
      returnValue.showCTA = true;
    } else {
      returnValue.error = createError('');
      returnValue.showCTA = true;
    }
  }
  return returnValue;
};

export default fetchOfferData;
